// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import { yznReq } from '../utils/yznhttp'
import Antd from 'ant-design-vue';
import $ from 'jquery';
import CONFIG_ from '../config/config';
import 'ant-design-vue/dist/antd.css';
import MetaInfo from 'vue-meta-info';

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer';
import 'vue-directive-image-previewer/dist/assets/style.css';
Vue.use(VueDirectiveImagePreviewer)

Vue.use(MetaInfo)
Vue.use(Antd);
// Vue.prototype.yznReq = yznReq;
Vue.config.productionTip = false;
Vue.prototype.CONFIG = CONFIG_;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})

router.afterEach((to, from) => {
  window.scrollTo(0,0);
});



// WEBPACK FOOTER //
// ./src/main.js